import React from 'react';
import {WhiteMailIcon, WhitePhone} from "../icons";
import {Button, Input} from "../common";
import {ALERT_TYPES, BUTTON_TYPES} from "../../types";
import {useMutation} from "react-query";
import * as Yup from "yup";
import {phoneRegex} from "../../utils/regex";
import {useFormik} from "formik";
import {useAlert} from "../common/Alert";

interface ISchema {
  [key: string]: string;
  fio: string;
  phone: string;
  email: string;
}

const WriteUs = ({ handleOpenModal }: { handleOpenModal: () => void }) => {
  const { setAlert } = useAlert();

  const sendRequest = useMutation(["sendRequest"], {
    onMutate: (data: { fio: string; phone: string; email: string }) => {},
    onSuccess: () => {
      handleOpenModal()
    },
    onError: (e: any) => {
      const errorText: string = `${Object.values(e.response.data).flat(2)?.[0]}`;
      setAlert(errorText, ALERT_TYPES.ERROR);
    }
  })

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    fio: Yup.string().required('Поле не может быть пустым'),
    phone: Yup.string().required('Поле не может быть пустым')?.matches(phoneRegex, 'Невалидный номер телефона'),
    email: Yup.string()?.email('Невалидный email').required('Email не может быть пустым'),
  });

  const submitForm = async (values: any) => {
    const { fio, phone, email } = values;
    await sendRequest.mutate({
      fio, phone, email
    })

  }
  const formik = useFormik({
    initialValues: {
      fio: '',
      phone: '',
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <div className="max-w-[1720px] mx-auto py-10 mb-20 flex-col flex items-center justify-center relative mx-auto mt-[200px] bg-backgroundImage after:content-[''] after:absolute after:block after:inset-0 after:bg-black/90 after:z-0 lg:py-10">
      <p className="mb-3 text-white text-[32px] leading-[39px] font-bold relative z-10 pb-14">
        Присоединиться к команде
      </p>
      <div className="relative z-50 text-white flex items-center w-full px-5 max-w-[1320px] mx-auto lg:flex-col sm:py-2 sm:px-6">
        <div className="w-1/4 lg:w-full">
          <p className="mb-6 text-white font-bold text-[24px] leading-[29px]">Напишите нам</p>
          <div className="flex items-center gap-1 mb-6">
            <WhitePhone />
            <div>
              <p className="font-medium text-[16px] leading-[18px] text-white">+7 (963) 936-04-49</p>
              <span className="text-[14px] leading-[16px] text-white/50">Для звонков по России</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <WhiteMailIcon />
            <div>
              <p className="font-medium text-[16px] leading-[18px] text-white">partner@beetobee.org</p>
              <span className="text-[14px] leading-[16px] text-white/50">Адрес.эл почты</span>
            </div>
          </div>

        </div>

        <div className="h-[156px] w-[1px] bg-white/20 mx-16 lg:w-full lg:h-[2px] lg:my-8" />

        <div className="w-3/4 lg:w-full">
          <p className="font-bold text-[24px] leading-[29px] text-white">Нужна помощь? Давайте мы свяжемся с вами</p>
          <div className="flex items-center mt-2 justify-between gap-2 mb-6 lg:flex-col">
            <div className="w-1/3 lg:w-full lg:mb-3">
              <p className="font-medium text-[14px] leading-[24px] text-white">Ваше ФИО</p>
              <Input
                id="fio"
                name="fio"
                onChange={formik.handleChange}
                placeholder={'Введите свое ФИО'}
                error={touched?.fio ? errors?.fio : false}
                className="max-w-full w-full"
              />
            </div>

            <div className="w-1/3 lg:w-full lg:mb-3">
              <p className="font-medium text-[14px] leading-[24px] text-white">Телефон</p>
              <Input
                id="phone"
                name="phone"
                onChange={formik.handleChange}
                error={touched?.phone ? errors?.phone : false}
                className="max-w-full w-full"
                placeholder={'Введите ваш телефон'}
              />
            </div>

            <div className="w-1/3 lg:w-full lg:mb-3">
              <p className="font-medium text-[14px] leading-[24px] text-white">Электронная почта</p>
              <Input
                id="email"
                name="email"
                onChange={formik.handleChange}
                error={touched?.email ? errors?.email : false}
                className="max-w-full w-full"
                type={'email'}
                placeholder={'Введите вашу почту'}
              />
            </div>
          </div>
          <Button
            title={'Отправить заявку'}
            type={BUTTON_TYPES.SECONDARY}
            onClick={handleSubmit}
            className="lg:w-full"
          />
        </div>

      </div>
    </div>

  )
}

export default WriteUs;
